import { ActionData, ActionsOperators, IDataRule } from './data-rules-model';

export type AiContentDisclaimerVariant = 'will' | 'may';

/**
 * Action types that run an AI prompt directly (AI Assist, both field and note
 * output).
 */
export const AI_PROMPT_ACTION_TYPES: ReadonlyArray<string> = [
  ActionsOperators.AIASSIST,
  ActionsOperators.AIASSIST_NOTE
];

export const POSSIBLE_AI_CONTENT_ACTION_TYPES: ReadonlyArray<string> = [
  ActionsOperators.AWESOMEDOCS
];

function stepsIncludeType (steps: ActionData[] | null | undefined, types: ReadonlyArray<string>): boolean {
  return (steps ?? []).some((step) => !!step && types.includes(step.type));
}

/**
 * Which AI-content disclaimer variant (if any) a set of action steps requires:
 * - 'will' when a direct AI prompt action is present (takes precedence)
 * - 'may' when an AwesomeDocs/enrichment action is present without an AI prompt
 * - null when neither is present, i.e. no disclaimer is needed
 */
export function stepsAiContentDisclaimerVariant (steps: ActionData[] | null | undefined): AiContentDisclaimerVariant | null {
  if (stepsIncludeType(steps, AI_PROMPT_ACTION_TYPES))
    return 'will';
  if (stepsIncludeType(steps, POSSIBLE_AI_CONTENT_ACTION_TYPES))
    return 'may';
  return null;
}

/**
 * Which AI-content disclaimer variant (if any) a Rule requires.
 */
export function ruleAiContentDisclaimerVariant (rule: IDataRule | null | undefined): AiContentDisclaimerVariant | null {
  return stepsAiContentDisclaimerVariant(rule?.ruleData?.action?.config?.steps);
}
